import { Component, ChangeDetectorRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { CampaignService } from '../../../../common/services/Campaign.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { BaseComponent } from '../../../../components/base.component';

declare var $: any;
declare var Chartist: any;

@Component({
  templateUrl: 'campaign.template.html',
  styleUrls: ['campaign.css'],
  providers: [BsModalService, CampaignService],
})
export class CampaignComponent extends BaseComponent {
  public mode: any = 'list';
  public choice_campaign_id: any;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {}

  openMode($event) {
    this.mode = $event.mode;
    if (this.mode == 'detail') {
      this.choice_campaign_id = $event.id;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/campaign.component.ts